































import Vue from "vue";
import Component from "vue-class-component";
declare var google: any;
@Component({
	components: {},
	props: {
		locations: {
		  type: Object,
		  required: false
		},
		disableDefaultUI: {
		  type: Boolean,
		  required: false
		},
		zoom: {
		  type: Number,
		  required: false
		},
		scaleControl: {
		  type: Boolean,
		  required: false
		},
		zoomControl: {
		  type: Boolean,
		  required: false
		}   
	}
})
export default class Contacto extends Vue {
	map: any;
	bounds = new google.maps.LatLngBounds();

	mounted() {
    	this.map = this.initMap(); // have to wait untill DOM is ready    
    	
	}

	

	initMap(): any {
	    const element: any = this.$refs.googleMap;
	    return new google.maps.Map(element, {
	      zoom: 16,
	      center: new google.maps.LatLng(15.6633824, -96.5232638)
	    });
	}
}
